module.exports = function() {
  return new Worker(__webpack_public_path__ + "b2b29d93390e12458fe0.worker.js");
};